import { Component, HostListener, inject } from '@angular/core';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { I18nService } from '@shared/services/i18n.service';

@Component({
	selector: 'app-footer',
	imports: [TranslateModule, IconComponent],
	standalone: true,
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.scss',
})
export class FooterComponent {
	isFooterLanguageMenuOpen = false;
	currentYear = new Date().getFullYear();

	// Injected services
	public translateService = inject(TranslateService);
	public i18nService = inject(I18nService);

	/**
	 * Toggle footer language menu dropdown
	 */
	toggleFooterLanguageMenu(): void {
		this.isFooterLanguageMenuOpen = !this.isFooterLanguageMenuOpen;
	}

	/**
	 * Switch application language
	 */
	switchLanguage(lang: string): void {
		this.i18nService.changeLanguage(lang);
	}

	/**
	 * Handle clicks outside the footer language menu to close it
	 */
	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		const clickedElement = event.target as HTMLElement;

		// Check if the click is on the footer language toggle button (don't close in that case)
		const isClickOnToggle = clickedElement.closest('.weFooter__languageToggle');
		if (isClickOnToggle) {
			return;
		}

		// Check if the click is inside the footer language flyout
		const clickedFlyout = clickedElement.closest('.weFooter__languageFlyout');

		// Close the menu if clicking outside the flyout
		if (!clickedFlyout && this.isFooterLanguageMenuOpen) {
			this.isFooterLanguageMenuOpen = false;
		}
	}
}
